import React from "react";
import { GRUPOS } from "../constants/unidades";

export default function SeleccionEmpresa({ nombreUsuario, onSeleccionar, onLogout }) {
  function elegir(grupoId) {
    onSeleccionar(grupoId);
  }

  return (
    <div style={styles.bg}>
      <div style={styles.card}>
        <div style={styles.logoArea}>
          <div style={styles.logoCircle}>🍣</div>
          <h1 style={styles.brand}>Grupo Operador de<br />Alimentos y Marcas</h1>
          <p style={styles.sub}>{nombreUsuario ? `Hola, ${nombreUsuario}` : "Sistema de Administración"}</p>
        </div>

        <p style={styles.pregunta}>¿Con qué empresa quieres entrar?</p>

        <div style={styles.grid}>
          {GRUPOS.map(g => (
            <button
              key={g.id}
              onClick={() => elegir(g.id)}
              style={styles.opcion}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#C8A96E"; e.currentTarget.style.background = "#1a1610"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#2a2a2a"; e.currentTarget.style.background = "#161410"; }}
            >
              <span style={styles.opcionIcono}>{g.icono}</span>
              <span style={styles.opcionNombre}>{g.nombre}</span>
            </button>
          ))}
        </div>

        <button style={styles.logoutBtn} onClick={onLogout}>Cerrar sesión</button>
      </div>
    </div>
  );
}

const styles = {
  bg: { minHeight: "100vh", background: "linear-gradient(135deg, #0a0a0a 0%, #1a1410 50%, #0a0a0a 100%)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', padding: "20px" },
  card: { background: "#111", border: "1px solid #2a2a2a", borderRadius: "16px", padding: "48px 40px", width: "100%", maxWidth: "440px", boxShadow: "0 40px 80px rgba(0,0,0,0.8)" },
  logoArea: { textAlign: "center", marginBottom: "20px" },
  logoCircle: { fontSize: "48px", marginBottom: "12px", display: "block" },
  brand: { color: "#C8A96E", fontSize: "19px", fontWeight: "600", letterSpacing: "1px", lineHeight: "1.35", margin: "0 0 6px", fontFamily: '-apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif' },
  sub: { color: "#666", fontSize: "13px", margin: 0, letterSpacing: "1px", fontFamily: "sans-serif" },
  pregunta: { color: "#bbb", fontSize: "14px", textAlign: "center", margin: "24px 0 20px", fontFamily: "sans-serif" },
  grid: { display: "flex", flexDirection: "column", gap: "12px" },
  opcion: { display: "flex", alignItems: "center", gap: "14px", width: "100%", background: "#161410", border: "1px solid #2a2a2a", borderRadius: "10px", padding: "16px 18px", cursor: "pointer", transition: "all 0.15s", textAlign: "left" },
  opcionIcono: { fontSize: "26px" },
  opcionNombre: { color: "#eee", fontSize: "16px", fontFamily: "sans-serif", fontWeight: "600", flex: 1 },
  logoutBtn: { width: "100%", background: "transparent", border: "1px solid #2a2a2a", borderRadius: "8px", padding: "12px", color: "#666", fontSize: "13px", cursor: "pointer", fontFamily: "sans-serif", marginTop: "28px" }
};
